module.exports = __webpack_public_path__ + "static/media/001-balloon-green.0270a439.svg";